import React from 'react';
import './subHeader.scss';

const headerSummary = ({ productTitle = '', showHeaderBackBtn = true, handleGoBack = () => {} }) => {
  return (
    <section className="sub_header">
      <div className="container">
        <div className="header_title">
          <span className="back" onClick={handleGoBack}>
            <i className="material-icons">chevron_left</i> <small>Go Back</small>
          </span>
          <span className="title_text">{productTitle}</span>
        </div>
      </div>
    </section>
  );
};
export default headerSummary;
